import '@mathflat/design-system-2024/styles'

import type { DesignSystemTypes } from '@mathflat/design-system-2024'
import { createSwitch } from '@mathflat/design-system-2024'

const { Switch: DesignSystemSwitch } = createSwitch({
  checked: 'var(--Colors-Blue-500)',
  checkedHover: 'var(--Colors-Blue-600)',
  unchecked: 'var(--Colors-Gray-500)',
  uncheckedHover: 'var(--Colors-Gray-600)',
  focusRingColor: 'var(--Colors-Sky-600)',
})

/**
 * @description on/off 상황에서 사용하는 스위치(토글) 컴포넌트입니다.
 * @checked 체크 상태 boolean
 * @onCheckedChange 체크 상태 변경 시 실행되는 함수 (checked) => void
 */
export const Switch = ({
  size,
  checked,
  onCheckedChange,
  disabled,
}: {
  size: DesignSystemTypes.CommonSize
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}) => {
  return (
    <DesignSystemSwitch
      size={size}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
    />
  )
}
